window.contacts = function () {
  const $form_contact = $("#form_contact");
  const validator = $form_contact.validate({
    rules: {
      contact_name: "required",
      contact_contact: "required",
      contact_address: "required",
      email: {
        required: true,
        email: true,
      },
      contact_accept_news: "required",
      contact_accept_terms: "required",
      contact_accept_emails: "required",
    },
    messages: {
      contact_name: trans("all.The name is a required field"),
      contact_contact: trans("all.The contact is a required field"),
      contact_address: trans("all.The adress is a required field"),
      contact_message: trans("all.The Message is a required field"),
      contact_email: {
        required: trans("all.We need your email address to contact you"),
        email: trans(
          "all.Your email address must be in the format of name@domain",
        ),
      },
      contact_accept_news: "*",
      contact_accept_terms: "*",
      contact_accept_emails: "*",
    },
    submitHandler: function (form, e) {
      console.log(e);

      //
      const $form = $(form);
      var formData = {
        _token: $form.find('[name="_token"]').val(),
        contact_name: $form.find('[name="contact_name"]').val(),
        contact_contact: $form.find('[name="contact_contact"]').val(),
        contact_address: $form.find('[name="contact_address"]').val(),
        contact_email: $form.find('[name="contact_email"]').val(),
        contact_website: $form.find('[name="contact_website"]').val(),
        contact_accept_news: $form
          .find('[name="contact_accept_news"]')
          .prop("checked")
          ? "on"
          : "off",
        contact_accept_terms: $form
          .find('[name="contact_accept_terms"]')
          .prop("checked")
          ? "on"
          : "off",
        contact_accept_emails: $form
          .find('[name="contact_accept_emails"]')
          .prop("checked")
          ? "on"
          : "off",
        contact_message: $form.find('[name="contact_messages"]').val(),
      };
      $.ajax({
        type: "POST",
        url: form.action,
        data: formData,
        dataType: "json",
        encode: true,
      }).done(function (data) {
        console.log(data);
        alert("Well done ");
      });
      e.preventDefault();
      e.stopPropagation();
    },
    invalidHandler: function () {
      if (validator.numberOfInvalids() > 0) {
        // checks form for validity
        $form_contact.find("button.btn").prop("disabled", false); // enables button
      } else {
        $form_contact.find("button.btn").prop("disabled", "disabled"); // disables button
      }
    },
  });

  // $form_contact.on('keyup blur click', function () { // fires on every keyup & blur
  //   if (validator.numberOfInvalids() > 0) {                   // checks form for validity
  //     $form_contact.find('button.btn').prop('disabled', false);        // enables button
  //   } else {
  //     $form_contact.find('button.btn').prop('disabled', 'disabled');   // disables button
  //   }
  // });
};
